import { createBrowserRouter, Navigate } from "react-router";
import { MainLayout } from "@/layouts/MainLayout";
import { ManagementLayout } from "@/layouts/ManagementLayout";
import { LoginPage } from "@/pages/Login";
import { SsoLoginPage } from "@/pages/SsoLogin";
import { SsoCallbackPage } from "@/pages/SsoCallback";
import { ComingSoon } from "@/pages/management/placeholders/ComingSoon";
import { UserManagement } from "@/pages/management/system/UserManagement";
import { OrgManagement } from "@/pages/management/system/OrgManagement";
import { OrgSettings } from "@/pages/management/org/OrgSettings";
import { RoleManagement } from "@/pages/management/org/RoleManagement";
import { MemberManagement } from "@/pages/management/org/MemberManagement";
import { SsoConfig } from "@/pages/management/org/SsoConfig";
import { ClientManagement } from "@/pages/management/org/ClientManagement";
import { ProviderManagement } from "@/pages/management/org/ProviderManagement";
import { McpManagement } from "@/pages/management/org/McpManagement";
import { SkillManagement } from "@/pages/management/org/SkillManagement";
import { AgentWorkspace } from "@/pages/agents/AgentWorkspace";
import { AgentManagement } from "@/pages/management/org/AgentManagement";
import { UserMcpPage } from "@/pages/mcps/UserMcpPage";
import { UserSkillPage } from "@/pages/skills/UserSkillPage";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/sso/login/:orgId", element: <SsoLoginPage /> },
  { path: "/sso/callback", element: <SsoCallbackPage /> },
  {
    element: <MainLayout />,
    children: [
      { path: "/agents", element: <AgentWorkspace /> },
      { path: "/mcps", element: <UserMcpPage /> },
      { path: "/skills", element: <UserSkillPage /> },
      { path: "/documents", element: <ComingSoon /> },
      {
        path: "/management",
        element: <ManagementLayout />,
        children: [
          { index: true, element: null },
          // System context
          { path: "system/users", element: <UserManagement /> },
          { path: "system/orgs", element: <OrgManagement /> },
          // Org context
          { path: "org/:orgId/settings", element: <OrgSettings /> },
          { path: "org/:orgId/roles", element: <RoleManagement /> },
          { path: "org/:orgId/members", element: <MemberManagement /> },
          { path: "org/:orgId/sso", element: <SsoConfig /> },
          // Phase 2+ placeholders
          { path: "org/:orgId/agents", element: <AgentManagement /> },
          { path: "org/:orgId/mcps", element: <McpManagement /> },
          { path: "org/:orgId/skills", element: <SkillManagement /> },
          { path: "org/:orgId/providers", element: <ProviderManagement /> },
          { path: "org/:orgId/clients", element: <ClientManagement /> },
        ],
      },
    ],
  },
  { path: "*", element: <Navigate to="/management" replace /> },
]);
